import one from '../assets/svg/projects/one.svg'
import two from '../assets/svg/projects/two.svg'
import three from '../assets/svg/projects/three.svg'
import four from '../assets/svg/projects/four.svg'
import five from '../assets/svg/projects/five.svg'
import six from '../assets/svg/projects/six.svg'

export const projectsData = [
    {
        id: 1,
        projectName: 'Connect and meet',
        projectDesc: 'This project aims to build an dating application that manages the data like instagram',
        tags: ['Angular', 'Ionic', 'FIREBASE','HTML','CSS','JS','BOOTSTRAP'],
        // code: 'https://github.com/cse5a/E-LIBRARY',
        //demo: 'https://github.com/hhhrrrttt222111/developer-portfolio',
        image: one
    },
    {
        id: 2,
        projectName: 'Kaboodle',
        projectDesc: 'This project is a student management system that manages all the imformation of students.',
        tags: ['Ionic','Angular', 'HTML','CSS','Bootstrap','Firebase','node js'],
        // code: 'https://github.com/sipundhal/WeatherProjectFrontEnd',
        //demo: 'https://github.com/hhhrrrttt222111/developer-portfolio',
        image: two
    },
    
    
]


// Do not remove any fields.
// Leave it blank instead as shown below

/* 
{
    id: 1,
    projectName: 'Car Pooling System',
    projectDesc: '',
    tags: ['Flutter', 'React'],
    code: '',
    demo: '',
    image: ''
}, 
*/